<p-dialog
  [header]="useHeader"
  [(visible)]="visible"
  (onHide)="hideDialog($event)"
  (onShow)="showDialog($event)"
  [modal]="modal"
  [draggable]="draggable"
  [closable]="closable"
  closeIcon="pi pi-close"
  [baseZIndex]="baseZIndex"
  [styleClass]="
    dialogSize === 'small'
      ? 'p-dialog-sm'
      : dialogSize === 'large'
      ? 'p-dialog-lg'
      : 'p-dialog-md'
  "
  contentStyleClass="content-dialog"
  appendTo="body"
>
  <div class="mt-10">
    <ng-content></ng-content>
  </div>
  <ng-template pTemplate="header">
    <ng-container *ngIf="headerTemplate">
      <ng-template *ngTemplateOutlet="headerTemplate"></ng-template>
    </ng-container>
  </ng-template>
  <ng-template #defaultFooter pTemplate="footer">
    <ng-container *ngIf="footerTemplate; else defaultFooter">
      <ng-template *ngTemplateOutlet="footerTemplate"></ng-template>
    </ng-container>
    <ng-template #defaultFooter>
      <div class="p-d-flex p-jc-center">
        <button
          *ngIf="showCancel"
          pButton
          type="button"
          label="{{ displayCancelText | translate }}"
          (click)="cancelBtnClick($event)"
          class="p-button-secondary p-content-button p-mr-2"
        ></button>
        <button
          *ngIf="showConfirm"
          pButton
          type="button"
          label="{{ displayConfirmText | translate }}"
          (click)="confirmBtnClick($event)"
          class="p-content-button"
        ></button>
      </div>
    </ng-template>
  </ng-template>
</p-dialog>
